// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3gjQu","footer":"ModalFilter_footer__CmhlO"};